export default "__VITE_ASSET__DGliNPT6__"